import React from 'react';

import {useQuill} from 'react-quilljs';
// or const { useQuill } = require('react-quilljs');

import 'quill/dist/quill.snow.css'; // Add css for snow theme
// or import 'quill/dist/quill.bubble.css'; // Add css for bubble theme

type EditorProps = {
    initialValue: string,
    onChange?: (res: string) => void,
    className?: string
}

type ViewerProps = {
    className?: string
    initialValue: string,
}

export function RichTextView({initialValue, className}: ViewerProps) {
    // todo - remove the border.
    const {quill, quillRef} = useQuill({
        modules: {
             toolbar: null
        },
        readOnly: true
    });
    React.useEffect(() => {
        if (quill) {
            quill.clipboard.dangerouslyPasteHTML(initialValue);
            // console.log(quill)
        }
    }, [quill]);
    return (
        <div className={className? className: ""}>
            <div className="!border-0" ref={quillRef}/>
        </div>
    );

}

export function RichTextEditor({initialValue, onChange, className}: EditorProps) {
    const {quill, quillRef} = useQuill({
        modules: {
             toolbar: true
        }
    });

    React.useEffect(() => {
        if (quill) {
            quill.clipboard.dangerouslyPasteHTML(initialValue);
            quill.on('text-change',

                (delta, oldDelta, source) => {
                    if (onChange) {
                        onChange(quill.root.innerHTML);
                    }
                    //console.log('Text change!');
                    // console.log(quill.getText()); // Get text only
                    // console.log(quill.getContents()); // Get delta contents
                    // console.log(quill.root.innerHTML); // Get innerHTML using quill
                    // console.log(quillRef.current.firstChild.innerHTML); // Get innerHTML using quillRef
                });
        }
    }, [quill]);


    return (
        <div
            // style={{width: 500, height: 300}}
        >
            <div ref={quillRef}/>
        </div>
    );
};